export const WLOST_603 = 'Revenir à l\'historique de connexion';